export class ProductPrint {
    CalculationWeight: number;
    Id_Owner: number;
    Id_Product: number;
    Id_ProductCategory: number;
    NWeek: number;
    ProductCategoryName: string;
    ProductName: string;
    RecipeString: string;
    PrintThis: boolean;
    PersonalComment: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/product-print-model.ts